import { axios, transformAxiosError } from "../utils/axios.create";
import {
  AppVersion,
  CreateAppVersionPayload,
  UpdateAppVersionPayload,
  GetAppVersionsParams,
  CurrentAppVersion,
} from "../domain/appVersion.interface";

const findAll = async (
  params?: GetAppVersionsParams,
): Promise<AppVersion[]> => {
  const queryParams = new URLSearchParams();
  if (params?.isCurrent !== undefined) {
    queryParams.append("isCurrent", params.isCurrent.toString());
  }
  if (params?.platform) {
    queryParams.append("platform", params.platform);
  }

  const url = queryParams.toString()
    ? `/app-versions?${queryParams.toString()}`
    : "/app-versions";

  return axios
    .get(url)
    .then((res) => {
      return res.data.body as AppVersion[];
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const findCurrent = async (platform: string): Promise<CurrentAppVersion> => {
  return axios
    .get(`/app-versions/current?platform=${platform}`)
    .then((res) => {
      return res.data.body as CurrentAppVersion;
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const create = async (
  payload: CreateAppVersionPayload,
): Promise<AppVersion> => {
  return axios
    .post("/app-versions", payload)
    .then((res) => res.data.body as AppVersion)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const update = async (
  appVersionId: string,
  payload: UpdateAppVersionPayload,
): Promise<AppVersion> => {
  return axios
    .put(`/app-versions/${appVersionId}`, payload)
    .then((res) => res.data.body as AppVersion)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const softDelete = async (appVersionId: string): Promise<void> => {
  return axios
    .delete(`/app-versions/${appVersionId}`)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const setCurrent = async (
  appVersionId: string,
  platform: string,
): Promise<AppVersion> => {
  return axios
    .patch(`/app-versions/${appVersionId}/current`, {
      platform,
    })
    .then((res) => res.data.body as AppVersion)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

export const AppVersionService = {
  findAll,
  findCurrent,
  create,
  update,
  softDelete,
  setCurrent,
};
